const directDownloadFile = (url: string, fileName = "") => {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
};
export default directDownloadFile;
